import { render, staticRenderFns } from "./SponsoredRecommendationMultiTitleHomeGlobal.vue?vue&type=template&id=98be4748&scoped=true"
import script from "./SponsoredRecommendationMultiTitleHomeGlobal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationMultiTitleHomeGlobal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationMultiTitleHomeGlobal.vue?vue&type=style&index=0&id=98be4748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98be4748",
  null
  
)

export default component.exports